// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__324Dj","title":"Info_title__3qZMO","selects":"Info_selects__TJK6G","requiredAsterisk":"Info_requiredAsterisk__2gl2l"};